import '../zubie-geo-address';

import {html, render} from 'lit';
import {TripStop} from '../api/trips-api';
import {
  dayjs,
  timestampsToDaysHoursMinutes,
  utcToLocalTimestamp,
} from '../services/date';
import {isReverseGeocodingEnabled} from '../services/geocode';

export default function (point: TripStop) {
  const popup = document.createElement('div');

  const address = point.arrival.address || point.departure.address;

  const place = point.arrival.place?.name || point.departure.place?.name;

  const template = html` <div class="contents trip-popup">
    ${point.label
      ? html` <h5 class="text-dark-grey text-capitalize">
          Stop ${point.label}
        </h5>`
      : ''}
    ${place ? html` <div class="place">${place}</div> ` : ''}
    ${isReverseGeocodingEnabled() || address
      ? html`<zubie-geo-address
          class="address"
          street="${address?.street}"
          city="${address?.city}"
          state="${address?.state}"
          latitude="${point.coordinates[1]}"
          longitude="${point.coordinates[0]}"
        />`
      : ''}
    ${tripPopupStats(point)}
  </div>`;

  render(template, popup);

  return popup;
}

export function tripPopupStats(point: TripStop) {
  const arrivalTimestamp = point.arrival.timestamp_utc;
  const departureTimestamp = point.departure.timestamp_utc;

  const stats = [];

  if (arrivalTimestamp) {
    stats.push({
      label: 'Arrived',
      value: dayjs.utc(arrivalTimestamp).local(),
    });
  }

  if (departureTimestamp) {
    stats.push({
      label: 'Left',
      value: dayjs.utc(departureTimestamp).local(),
    });
  }

  if (arrivalTimestamp && departureTimestamp) {
    stats.push({
      label: 'Duration',
      value: timestampsToDaysHoursMinutes(arrivalTimestamp, departureTimestamp),
    });
  }

  if (stats.length === 0) {
    return '';
  }

  return html` <div class="trip-stats column">
    ${stats.map((stat) => {
      const humanValue = dayjs.isDayjs(stat.value)
        ? utcToLocalTimestamp(stat.value.format())
        : stat.value;

      return html` <div class="trip-stat row justify-between items-center">
        ${stat.label
          ? html` <div class="trip-stat__label">${stat.label}</div>`
          : ''}
        <div class="trip-stat__value">${humanValue}</div>
      </div>`;
    })}
  </div>`;
}
